<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" :key="1" ripple> {{ $t("settingsPage.tabGeneral") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <GeneralSettings />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("settingsPage.tabOnboardingVouchers") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <OnboardingVouchersSettings />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="3" ripple> {{ $t("settingsPage.tabMobileVersions") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <MobileVersionsSettings />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="4" ripple> {{ $t("settingsPage.tabServiceCommissions") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <ServiceCommissionsSettings />
        </div>
      </v-tab-item>
    </v-tabs>


  </div>
</template>

<script>

import GeneralSettings from "@/views/settings/GeneralSettings";
import OnboardingVouchersSettings from "@/views/settings/OnboardingVouchersSettings";
import MobileVersionsSettings from "@/views/settings/MobileVersionsSettings";
import ServiceCommissionsSettings from "@/views/settings/ServiceCommissionsSettings";

export default {
  name: "Settings",
  title() {
    return this.$t("settingsPage.pageTitle");
  },
  components: {
    OnboardingVouchersSettings,
    GeneralSettings,
    MobileVersionsSettings,
    ServiceCommissionsSettings
  },
  data() {
    return {
      active: 0,
    };
  },

};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
